<template>
  <div class="app-container min-h-screen bg-gray-100">
    <!-- 导航菜单 -->
    <el-menu
      mode="horizontal"
      router
      :default-active="activeIndex"
      class="border-b bg-white shadow-sm"
    >
      <div class="max-w-7xl mx-auto px-4 flex items-center justify-between">
        <div class="flex items-center">
          <img alt="Vue logo" src="./assets/logo.png" class="h-8 mr-4">
          <h1 class="text-xl font-bold text-gray-800">深圳示例项目</h1>
        </div>
        <div class="flex-1 flex justify-center">
          <el-menu-item index="/" route="/">首页</el-menu-item>
          <el-menu-item index="/empty" route="/empty">空白页面</el-menu-item>
          <el-menu-item index="/about" route="/about">关于我们</el-menu-item>
        </div>
        <div>
          <el-dropdown>
            <el-avatar :icon="UserFilled" />
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>个人中心</el-dropdown-item>
                <el-dropdown-item>设置</el-dropdown-item>
                <el-dropdown-item divided>退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </el-menu>

    <!-- 主要内容区域 -->
    <div class="main-content py-6">
      <!-- 路由视图 -->
      <router-view />
    </div>

    <!-- 页脚 -->
    <footer class="bg-gray-800 text-white py-6">
      <div class="max-w-7xl mx-auto px-4">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <div class="mb-4 md:mb-0">
            <h3 class="text-lg font-semibold">深圳示例项目</h3>
            <p class="text-gray-400 text-sm">&copy; 2025 深圳科技有限公司. 所有权利保留.</p>
          </div>
          <div class="flex space-x-4">
            <el-button type="primary" plain size="small" :icon="Location">联系我们</el-button>
            <el-button type="success" plain size="small" :icon="Message">反馈建议</el-button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from 'vue'
import { UserFilled, Location, Message } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  setup() {
    // 获取当前路由
    const route = useRoute()
    
    // 根据当前路由设置活动菜单
    const activeIndex = ref(route.path)

    return {
      // 数据
      activeIndex,
      // 图标
      UserFilled,
      Location,
      Message
    }
  }
}
</script>

<!-- 使用Tailwind CSS，不需要额外的样式 -->
